import { createFileRoute } from "@tanstack/react-router";
import { parseAuthSearch } from "./login";

/** `/register` — see `routes/login.tsx`; rendered by `__root.tsx`'s auth branch. */
export const Route = createFileRoute("/register")({
  validateSearch: parseAuthSearch,
  component: () => null,
});
